import { render, staticRenderFns } from "./ProductMarketing.vue?vue&type=template&id=26f76c6a&"
import script from "./ProductMarketing.vue?vue&type=script&lang=js&"
export * from "./ProductMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports